import { render, staticRenderFns } from "./NsbBlackList.vue?vue&type=template&id=64e548ac&scoped=true&"
import script from "./NsbBlackList.vue?vue&type=script&lang=js&"
export * from "./NsbBlackList.vue?vue&type=script&lang=js&"
import style0 from "./NsbBlackList.vue?vue&type=style&index=0&id=64e548ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e548ac",
  null
  
)

export default component.exports